// MF-554 — Shared helpers of the Chart Library (catalog page, item detail, Board Builder panel).
import { COLS } from '../Builder/layout'
import { GRID_GAP, ROW_HEIGHT } from '../boardTheme'

/** Text a search matches: title, viewer description, builder purpose, group, labels, sources. */
export const searchText = (i) =>
  [i.title, i.description, i.purpose, i.group, i.kind, ...(i.tags || []), ...(i.sources || [])]
    .join(' ')
    .toLowerCase()

/** Every word of the query must appear somewhere (so "attendance term" finds "Attendance by term"). */
export const matches = (item, q) => {
  const words = String(q || '')
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
  if (!words.length) return true
  const text = searchText(item)
  return words.every((w) => text.includes(w))
}

/** Labels with how many items carry them, most used first. */
export const tagCounts = (items = []) => {
  const m = new Map()
  for (const i of items) for (const t of i.tags || []) m.set(t, (m.get(t) || 0) + 1)
  return [...m.entries()].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
}

/**
 * Pixel size an item gets on a Board at its default size, on a ~1200px wide board — so the
 * preview shows it as it will look, not squeezed into an arbitrary box.
 */
export const defaultPixelSize = (item, boardWidth = 1200) => {
  const colW = (boardWidth - GRID_GAP * (COLS - 1)) / COLS
  const w = item?.layout?.defaultW || 4
  const h = item?.layout?.defaultH || 6
  return { width: Math.round(w * colW + (w - 1) * GRID_GAP), height: h * ROW_HEIGHT + (h - 1) * GRID_GAP }
}

export const AUDIENCE_TEXT = (a = {}, sensitive = false) =>
  [
    a.staff ? 'Staff (whole school)' : null,
    a.student === 'self' ? 'Students (only their own data)' : null,
    a.parent === 'children' ? 'Parents (only their children)' : null,
    sensitive ? 'Sensitive: staff only' : null
  ].filter(Boolean)
